module.exports = __webpack_public_path__ + "static/media/nordwood-themes-Nv4QHkTVEaI-unsplash1.69d81860.jpg";